define('views/components/cd_personal/cd_personal',['require','backbone','text!templates/components/cd_personal/cd_personal.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/cd_personal/cd_personal.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'distirbutor-personal-item'
    });
});
